import api from './api';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

// Configurar Pusher en la ventana global para que Echo lo encuentre
window.Pusher = Pusher;

let globalEchoInstance = null;

export const initEcho = (token) => {
    if (globalEchoInstance) {
        return globalEchoInstance;
    }

    console.log('Initializing Echo with:', {
        key: import.meta.env.VITE_REVERB_APP_KEY,
        host: import.meta.env.VITE_REVERB_HOST,
        port: import.meta.env.VITE_REVERB_PORT,
        scheme: import.meta.env.VITE_REVERB_SCHEME
    });

    try {
        globalEchoInstance = new Echo({
            broadcaster: 'reverb',
            key: import.meta.env.VITE_REVERB_APP_KEY,
            wsHost: import.meta.env.VITE_REVERB_HOST,
            wsPort: import.meta.env.VITE_REVERB_PORT ?? 8080,
            wssPort: import.meta.env.VITE_REVERB_PORT ?? 8080,
            forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
            enabledTransports: ['ws', 'wss'],
            authEndpoint: `${API_URL.replace(/\/+$/, '')}/api/broadcasting/auth`,
            auth: {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        });

        globalEchoInstance.connector.pusher.connection.bind('state_change', (states) => {
            console.log("Echo connection state: ", states.current);
        });
        globalEchoInstance.connector.pusher.connection.bind('error', (err) => {
            console.error("Echo connection error: ", err);
        });

        return globalEchoInstance;
    } catch (error) {
        console.error("Error initializing Echo:", error);
        return null;
    }
};

const getNotifications = async (page = 1) => {
    const response = await api.get(`/notifications?page=${page}`);
    return response.data;
};

const markAsRead = async (id) => {
    const response = await api.post(`/notifications/${id}/read`);
    return response.data;
};

const markAllAsRead = async () => {
    const response = await api.post(`/notifications/read-all`);
    return response.data;
};

const deleteRead = async () => {
    const response = await api.delete(`/notifications/read`);
    return response.data;
};

export default {
    getNotifications,
    markAsRead,
    markAllAsRead,
    deleteRead,
    initEcho
};
